import { render, staticRenderFns } from "./loginDia.vue?vue&type=template&id=39923b2f&scoped=true&"
import script from "./loginDia.vue?vue&type=script&lang=js&"
export * from "./loginDia.vue?vue&type=script&lang=js&"
import style0 from "./loginDia.vue?vue&type=style&index=0&id=39923b2f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39923b2f",
  null
  
)

export default component.exports